<template>
  <!-- 个人中心侧边栏 -->
  <div class="wrapper-content" v-loading="loading">
    <div class="side-list-box">
      <div class="side-container">
        <div class="edit-box" @click="editInfo">
          <i class="iconfont el-icon-edit-outline"></i>
        </div>
        <div class="user-img-box">
          <el-upload
            :show-file-list="false"
            :on-success="successUpload"
            class="upload-box"
            :action="uploadUrl"
            :before-upload="beforeAvatarUpload"
          >
            <div
              class="img"
              :style="{ backgroundImage: 'url( '  + myInfo.avatar + ')' }"
              v-if="myInfo.avatar"
            ></div>
            <template v-else>
              <i class="el-icon-camera-solid"></i>
            </template>
          </el-upload>
        </div>
        <div class="name-text">
          {{myInfo.real_name?myInfo.real_name:'姓名'}}
          <span
            @click="exitLogin"
          >{{!isLogin?'登录':'退出登录'}}</span>
        </div>
        <div class="num-box">
          <div class="num-list">
            {{courseTotal}}
            <span>课程数</span>
          </div>
          <div class="num-list">
            {{cardListLength}}
            <span>证书数</span>
          </div>
        </div>
        <div class="side-box">
          <div
            class="side-list"
            :class="sideActive === index ? 'side-active' : ''"
            v-for="(item, index) in sideList"
            :key="'side' + index"
            @click="sideSelect(item, index)"
          >{{ item.name }}</div>
        </div>
      </div>
    </div>
    <slot></slot>
    <div v-if="!isLogin">
      <login></login>
    </div>
  </div>
</template>
<script>
import api from '../api/api';
import { upload_url } from '../api/index';
import { imgUrl } from '../api/index';
import login from '../components/login.vue';
import { mapMutations, mapState } from 'vuex';
import {
  apiCollection,
  apiResource,
  apiFormSubmit,
  apiDelete,
  apiPut
} from '../api/index';
export default {
  components: {
    login
  },
  data() {
    return {
      sideList: [
        {
          name: '我的课程',
          url: 'myCourse',
          index: 0
        },
        {
          name: '荣誉殿堂',
          url: 'myCard',
          index: 1
        },
        {
          name: '我的证书',
          url: 'myCard',
          index: 2
        },
        {
          name: '商品订单',
          url: 'commodityOrder',
          index: 3
        },
        {
          name: '直播记录',
          url: 'playRecord',
          index: 4
        },
        {
          name: '我要加入',
          url: 'joinUs',
          index: 5
        },
        {
          name: '消息通知',
          url: 'message',
          index: 6
        }
      ],
      sideActive: '',
      info: {},
      myImg: '',
      uploadUrl: upload_url,
      imgUrl: imgUrl,
      courseTotal: '',
      cardListLength: '',
      cardList: [],
      myInfo: {},
      loading: true,
      isLogin: false
    };
  },
  computed: {
    ...mapState({
      //   isLogin: state => state.isLogin
    })
    // isLogin() {
    //   const value = localStorage.getItem('X-Access-Token');
    //   //   this.getIslogin(value ? true : false);
    //   if (value) {
    //     const arr = [
    //       apiCollection,
    //       apiResource,
    //       apiFormSubmit,
    //       apiDelete,
    //       apiPut
    //     ];
    //     arr.forEach(item => {
    //       item.defaults.headers['X-Access-Token'] = value;
    //     });
    //     return true;
    //   } else {
    //     const name = this.$route.name;
    //     return false;
    //   }
    // }
  },

  mounted() {
    this.setActiveIndex();
    const isLogin = localStorage.getItem('X-Access-Token');
    console.log(isLogin);
    console.log(this.isLogin);

    if (isLogin) {
      this.isLogin = isLogin;
      const arr = [
        apiCollection,
        apiResource,
        apiFormSubmit,
        apiDelete,
        apiPut
      ];
      arr.forEach(item => {
        item.defaults.headers['X-Access-Token'] = isLogin;
      });
    }
    if (!isLogin) {
      //   this.isLogin = true;
      // this.$message.warning('请登录！');
      this.loading = false;
      return;
    }
    // this.getDetail();
    this.getMyCourseList();
    this.getHornorList();
    this.getMyAvatar();
  },
  methods: {
    //   获取头像
    getMyAvatar() {
      api.getMyAvatar().then(res => {
        if (res.result) {
          this.myInfo = res.result;
        }
      });
    },
    //   上传头像限制
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg';
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过10MB!');
      }
      return isJPG && isLt2M;
    },
    //   退出登录
    exitLogin() {
      if (!this.isLogin) {
        location.reload();
      } else {
        localStorage.removeItem('X-Access-Token');
        window.location.href = 'http://www.procaregroup.com/';
      }
    },
    //   获取课程列表
    getMyCourseList() {
      const params = {
        page_index: 1,
        page_size: 10,
        order_state: ''
      };
      api.getMyCourseList(params).then(res => {
        if (res && res.result) {
          this.courseTotal = res.result.total;
        }
      });
    },
    getHornorList() {
      const params = {
        type: 2
      };
      api.getHornorList(params).then(res => {
        this.cardList = res.result.data;
        this.cardListLength = this.cardList.length;
        this.loading = false;
      });
    },
    //   上传头像
    successUpload(res, file) {
      if (res.result) {
        api.uploadMyAvatar({ avatar: res.result }).then(result => {
          if (res.result) {
            this.$message.success('上传成功！');
            this.myImg = res.result;
          }
        });
      } else {
        this.$message.warning('上传失败！');
      }
    },
    //   获取详情
    getDetail() {
      api.getMyinfo().then(res => {
        if (res.result) {
          this.info = res.result;
        }
      });
    },
    sideSelect(item, index) {
      this.sideActive = index;
      this.$router.push({ path: `/${item.url}`, query: { name: item.name } });
    },
    setActiveIndex() {
      const name = this.$router.history.current.name;
      if (name === 'personalCenter' || name === 'editInfo') {
        return;
      }
      if (name === 'myCourseDetail' || name === 'evaluateCourse') {
        this.sideActive = 0;
        return;
      }
      if (name === 'orderDetail' || name === 'evaluateOrder') {
        this.sideActive = 3;
        return;
      }
      if (name === 'recordDetail') {
        this.sideActive = 4;
        return;
      }
      let indexValue = this.sideList.filter((item, index) => {
        return item.url === name;
      });
      const value = this.$route.query;
      if (value.name === '荣誉殿堂' || value.name === '我的证书') {
        this.sideActive = value.name === '荣誉殿堂' ? 1 : 2;
        return;
      }
      this.sideActive = indexValue[0].index;
    },
    // 编辑信息
    editInfo() {
      this.$router.push({ path: '/editInfo' });
    }
  }
};
</script>
<style lang="scss" scoped>
.side-container {
  padding: 22PX 6PX 63PX;
}
.edit-box {
  text-align: right;
  .iconfont {
    font-size: 26PX;
    color: #666666;
    cursor: pointer;
  }
}
.user-img-box {
  position: relative;
  width: 110PX;
  height: 110PX;
  margin: 0 auto;
  border: 1PX solid #f6ab2b;
  border-radius: 50%;
  .el-icon-camera-solid {
    position: absolute;
    font-size: 88PX;
    color: #666666;
    left: 50%;
    top: 10PX;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .img {
    position: absolute;
    width: 88PX;
    height: 88PX;
    left: 50%;
    top: 10PX;
    transform: translateX(-50%);
    background-color: #eeeeee;
    border-radius: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
}
.name-text {
  position: relative;
  padding: 20PX 0 46PX;
  font-size: 18PX;
  text-align: center;
  span {
    position: absolute;
    margin-left: 14PX;
    font-size: 16PX;
    color: #f1a475;
    text-decoration: underline;
    cursor: pointer;
  }
}
.num-box {
  display: flex;
  .num-list {
    width: 50%;
    font-size: 34PX;
    font-weight: bold;
    text-align: center;
    span {
      display: block;
      font-size: 16PX;
      color: #666666;
      font-weight: normal;
    }
  }
}
.side-box {
  padding: 66PX 0 0;
}
.side-list {
  // padding-bottom: 40PX;
  font-size: 20PX;
  text-align: center;
  line-height: 58PX;
  border-left: 4PX solid transparent;
  cursor: pointer;
  &:hover {
    color: #f6ab2b;
    background-color: #f9f9f9;
    border-left: 4PX solid #f1a373;
  }
}
.side-active {
  color: #f6ab2b;
  background-color: #f9f9f9;
  border-left: 4PX solid #f1a373;
}
.wrapper-content {
  display: flex;
  //   justify-content: space-between;
  width: 72%;
  padding-top: 52PX;
  margin: 0 auto 80PX;
}
.side-list-box {
  width: 21%;
  min-width: 220PX;
  margin-right: 40PX;
  background-color: #ffffff;
  border-radius: 10PX;
}
@media screen and (max-width: 1700PX) {
  .wrapper-content {
    width: 84%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/personalSidebar.vue